var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.error)?_c('div',_vm._l((_vm.error.data.errors),function(e,index){return _c('v-alert',{key:index,attrs:{"color":"error","dark":"","dense":""}},[_vm._v(_vm._s(e[0])+"\n  ")])}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }